import { LinkButton } from '@/components/ui';
import { BarbellGlyph } from '@/components/Logo';
import { ArrowRightIcon, BarbellIcon } from '@/lib/icons';

/**
 * Final CTA: the orange band. Charcoal type on orange — never white (brand book §3.3).
 */
export function FinalCta() {
  return (
    <section className="relative overflow-hidden bg-accent text-brand-charcoal">
      <div aria-hidden="true" className="l2f-noise pointer-events-none absolute inset-0 opacity-30" />
      <div className="relative mx-auto flex max-w-[1200px] 2xl:max-w-[1440px] min-[1920px]:max-w-[1720px] flex-col items-start gap-8 px-4 py-16 sm:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-center gap-6">
          <BarbellGlyph className="hidden h-12 w-auto shrink-0 text-brand-charcoal sm:block" />
          <div className="flex flex-col gap-3">
            <h2 className="max-w-[26ch] font-display text-[32px] font-black uppercase leading-[1.02] tracking-[-0.03em] sm:text-[44px]">
              Your next session is already drafted.
            </h2>
            <p className="max-w-[54ch] text-[15px] font-medium leading-relaxed">
              Start free, log today’s session in The Grid, and let the AI coach take the first look at your week. No card,
              no trial clock, no spreadsheet.
            </p>
          </div>
        </div>

        <div className="flex w-full flex-col gap-3 sm:w-auto">
          <LinkButton
            href="#pricing"
            size="lg"
            className="l2f-cta-primary border-2"
          >
            Start free — no card <ArrowRightIcon className="text-sm" />
          </LinkButton>
          <LinkButton
            href="#grid"
            size="lg"
            variant="outline"
            className="l2f-cta-button"
          >
            <BarbellIcon className="text-base" /> Log a set first
          </LinkButton>
          <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-brand-charcoal/70">
            Web · iOS · Android · watchOS
          </p>
        </div>
      </div>
    </section>
  );
}
